import { Form } from 'antd';

export const CommonForm = ({ children, form, onFinish }: { children: any; form: any; onFinish: any }) => {
  const formLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };
  return (
    <Form
      {...formLayout}
      layout={'vertical'}
      form={form}
      initialValues={{ layout: formLayout }}
      onFinish={onFinish}
      style={{ maxWidth: '900px' }}
    >
      {children}
    </Form>
  );
};
